require("jplist/new/jplist.core.min.js");
require("jplist/new/jplist.pagination-bundle.min.js");
require("jplist/new/jplist.sort-bundle.min.js");
require("jplist/new/jplist.filter-dropdown-bundle.min.js");
require("jplist/new/jplist.textbox-filter.min.js");
import "../../../../../../Haendlerverwaltung/plugins/wkfg3_haendlerverwaltung/js/user/modal";

import Handlebars from "handlebars";
import Commons from "oc-commons/Commons.js";
import "oc-commons/extensions/HandlebarsExtensions.js";
import I18N from "oc-I18N";
import Urls from "oc-commons/Urls.js";
import {defaultCatchAsError,defaultCatchAsWarning} from "oc-ui/errorHandling.js";

async function navigateToConfigurator(id) {
  let queryString = "table=Konfiguration&where.id=" + encodeURIComponent(id);
  const data = await APP.wkfgBackendApi.loadMetadata(queryString);
  if (data?.Konfiguration?.length > 0) {
    const configuration = data.Konfiguration.pop();
    if (configuration.Konfigurator == "Schrank") {
      window.open(
        APP.settings.schrankUrl +
          `?Code=${configuration.Code}&haendler=${APP.settings.haendler.id}`,
        "_blank"
      );
    } else if (configuration.Konfigurator == "Fronten") {
      window.open(
        APP.settings.frontenUrl +
          `?Code=${configuration.Code}&haendler=${configuration.HaendlerId}`,
        "_blank"
      );
    }
  }
}

function convertToCSV(objArray) {
  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "";

  for (var i = 0; i < array.length; i++) {
    var line = "";
    for (var index in array[i]) {
      if (line != "") line += ";";

      line += array[i][index];
    }

    str += line + "\r\n";
  }

  return str;
}

function exportCSVFile(headers, items, fileTitle) {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  var jsonObject = JSON.stringify(items);

  var csv = convertToCSV(jsonObject);

  var exportedFilenmae = fileTitle + ".csv" || "export.csv";

  var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export function configurationOfUser(element, filterConfig) {
  if(!filterConfig.haendler) {
    alert("Sie sind zwar Nutzer, aber kein eingetragender Händler! Bitte konktaktieren Sie einen Admin!");
    return;
  }
  const filterValues = _.map(
    _.filter(_.keys(filterConfig), function (key) {
      return key.startsWith("filter");
    }),
    function (key) {
      return filterConfig[key];
    }
  );

  const select = _.map(filterValues, function (value, index) {
    const tags = value.split(/\s*,\s*/);
    return tags.map(function (tag, index) {
      return {
        value: index === 0 ? "default" : "*[data-tags*='" + tag + "']",
        label: tag,
      };
    });
  });

  const currentTemplate = $("#configurationListOfUserTemplate").html();

  let queryString =
    "table=Konfiguration&where.HaendlerId=" +
    encodeURIComponent(filterConfig.haendler.id);

  const template = Handlebars.compile(currentTemplate);

  Handlebars.registerHelper("status", function (v1, v2, options) {
    if (v1 === v2) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  APP.wkfgBackendApi.loadMetadata(queryString).then((data) => {
    if (Commons.isEmpty(_.get(data, "Konfiguration"))) {
      element.html(I18N("Sie haben noch nichts gespeichert"));
    } else {
      console.log("data.Konfiguration", data.Konfiguration);
      if (template) {
        element.html(
          template({
            list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
            select: select,
          })
        );
      } else {
        element.html(
          template({
            list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
            select: select,
          })
        );
      }
      element.html(
        template({
          list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
          select: select,
        })
      );
      $(".delete_configuration", element).on("click", async function () {
        const result = await confirm(I18N("Sure?"));
        if (result) {
          const anchor = $(this);
          const id = anchor.attr("data-id");
          APP.wkfgBackendApi
            .deleteMetadata("Konfiguration", id)
            .then(() => anchor.closest(".tblItem").remove());
        }
      });
      $(".openInConfigurator", element).on("click", async function () {
        const anchor = $(this);
        const id = anchor.attr("data-id");
        navigateToConfigurator(id);
      });
      element.jplist({
        itemsBox: ".userConfigs",
        itemPath: ".tblItem",
        panelPath: ".jplist-panel",
      });
    }
  });
}

export function configurationOfHersteller(element, filterConfig) {
  const filterValues = _.map(
    _.filter(_.keys(filterConfig), function (key) {
      return key.startsWith("filter");
    }),
    function (key) {
      return filterConfig[key];
    }
  );

  const select = _.map(filterValues, function (value, index) {
    const tags = value.split(/\s*,\s*/);
    return tags.map(function (tag, index) {
      return {
        value: index === 0 ? "default" : "*[data-tags*='" + tag + "']",
        label: tag,
      };
    });
  });

  let queryString =
    "table=Konfiguration&where.HaendlerId=" +
    encodeURIComponent(filterConfig.haendler.id);

  const template = Handlebars.compile(
    $("#configurationListOfHerstellerTemplate").html()
  );

  Handlebars.registerHelper("status", function (v1, v2, options) {
    if (v1 === v2) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  APP.wkfgBackendApi.loadMetadata(queryString).then((data) => {
    if (Commons.isEmpty(_.get(data, "Konfiguration"))) {
      element.html(I18N("Sie haben noch nichts gespeichert"));
    } else {
      console.log("data.Konfiguration", data.Konfiguration);
      if (template) {
        element.html(
          template({
            list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
            select: select,
          })
        );
      } else {
        element.html(
          template({
            list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
            select: select,
          })
        );
      }
      element.html(
        template({
          list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
          select: select,
        })
      );
      $(".download", element).on("click", function () {
        var headers = {
          position: "Pos",
          kommission: "Kommission",
          code: "Auftragsnummer/Code",
          beschreibung: "Plattennummer/Artikel",
          verlauf: "Strukturverlauf",
          dekor: "Dekor (Name)",
          dekorbeschreibung: "Dekorbeschreibung",
          hoehe: "Höhe",
          breite: "Breite",
          menge: "Menge",
          lieferadresse: "Lieferadresse",
          rechungsadresse: "Rechungsadresse",
          preiseinzel: "Preis einzeln",
          aufschlag: "Preisaufschlag",
          gesamtpreis: "Preis gesamt",
        };

        const anchor = $(this);
        const id = anchor.attr("data-id");
        const itemsFormatted = [];
        const dataObject = data.Konfiguration.find((k) => k.id == id);

        const createAdress = (haendler) => {
          return haendler.Strasse + " | " + haendler.PLZ + " " + haendler.Stadt;
        };

        const stammdaten = dataObject.Json.stammdaten;
        const formatter = new Intl.NumberFormat("de-de", {
          currency: "EUR",
        });
        // format the data
        dataObject.Json.positionen.forEach((item) => {
          itemsFormatted.push({
            pos: item.fronten_position, // remove commas to avoid errors,
            kommission: dataObject.Json.haendler.Name,
            code: dataObject.Code,
            beschreibung: item.fronten_beschreibung,
            verlauf: item.fronten_verlauf,
            dekor: item.fronten_decor,
            dekorbeschreibung: item.fronten_dekorbeschreibung,
            hoehe: item.fronten_height,
            breite: item.fronten_width,
            menge: item.fronten_count,
            lieferadresse: dataObject.Json.haendler
              ? createAdress(dataObject.Json.haendler)
              : "",
            rechungsadresse: dataObject.Json.haendler
              ? createAdress(dataObject.Json.haendler)
              : "",
            preiseinzel: formatter.format(item.priceInfo.qmPrice),
            aufschlag: formatter.format(item.priceInfo.fixedPrice),
            gesamtpreis: formatter.format(item.fronten_sum),
          });
        });

        const fileTitle = dataObject.Code;

        exportCSVFile(headers, itemsFormatted, fileTitle);
      });
      $(".delete_configuration", element).on("click", async function () {
        const result = await confirm(I18N("Sure?"));
        if (result) {
          const anchor = $(this);
          const id = anchor.attr("data-id");
          APP.wkfgBackendApi
            .deleteMetadata("Konfiguration", id)
            .then(() => anchor.closest(".tblItem").remove());
        }
      });
      element.jplist({
        itemsBox: ".userConfigs",
        itemPath: ".tblItem",
        panelPath: ".jplist-panel",
      });
      
      $(".showCustomerData", element).on("click", function () {
        const anchor = $(this);
        const id = anchor.attr("data-id");
        const dataObject = data.Konfiguration.find((k) => k.id == id);
        showUserDataModal(dataObject);
      });
    }
  });
}

export function configurationOfVerkaeufer(element, filterConfig) {
  const filterValues = _.map(
    _.filter(_.keys(filterConfig), function (key) {
      return key.startsWith("filter");
    }),
    function (key) {
      return filterConfig[key];
    }
  );

  const select = _.map(filterValues, function (value, index) {
    const tags = value.split(/\s*,\s*/);
    return tags.map(function (tag, index) {
      return {
        value: index === 0 ? "default" : "*[data-tags*='" + tag + "']",
        label: tag,
      };
    });
  });

  let queryString =
    "table=Konfiguration&where.HaendlerId=" +
    encodeURIComponent(filterConfig.haendler.id);

  const template = Handlebars.compile(
    $("#configurationListOfVerkaeuferTemplate").html()
  );

  Handlebars.registerHelper("status", function (v1, v2, options) {
    if (v1 === v2) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  APP.wkfgBackendApi.loadMetadata(queryString).then((data) => {
    if (Commons.isEmpty(_.get(data, "Konfiguration"))) {
      element.html(I18N("Sie haben noch nichts gespeichert"));
    } else {
      console.log("data.Konfiguration", data.Konfiguration);
      if (template) {
        element.html(
          template({
            list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
            select: select,
          })
        );
      } else {
        element.html(
          template({
            list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
            select: select,
          })
        );
      }
      element.html(
        template({
          list: _.orderBy(data.Konfiguration, ["updated_at"], ["desc"]),
          select: select,
        })
      );

      $(".bestellen", element).on("click", function () {
        const anchor = $(this);
        const id = anchor.attr("data-id");
        const dataObject = data.Konfiguration.find((k) => k.id == id);
        showBestellenModal(dataObject, (dataObject) => {
            // dataObject.Auftragsstatus = "Bei Hersteller bestellt";
            APP.wkfgBackendApi
                .saveMetadata("Konfiguration", "update", dataObject)
                .then((res) => {});
            const url = Urls.addOrUpdateQsParameter(APP.wkfgBackendApi.wkfgBackendUrl + 'mail','Code', dataObject.Code);
            defaultCatchAsWarning($.get(url));
        });
      });
      $(".delete_configuration", element).on("click", async function () {
        const result = await confirm(I18N("Sure?"));
        if (result) {
          const anchor = $(this);
          const id = anchor.attr("data-id");
          APP.wkfgBackendApi
            .deleteMetadata("Konfiguration", id)
            .then(() => anchor.closest(".tblItem").remove());
        }
      });
      element.jplist({
        itemsBox: ".userConfigs",
        itemPath: ".tblItem",
        panelPath: ".jplist-panel",
      });

      $(".showCustomerData", element).on("click", function () {
        const anchor = $(this);
        const id = anchor.attr("data-id");
        const dataObject = data.Konfiguration.find((k) => k.id == id);
        showUserDataModal(dataObject);
      });
    }
  });
}

function showBestellenModal(dataObject, callback) {
  const content = `
    <h3>Liefertyp bei Hersteller</h3>
    <div style='width: 100%'>
      <input type='radio' id='lieferung' name='liefertyp' value='fronten_lieferung_hersteller_lieferung' checked>
      <label for='lieferung'>${I18N(
        "fronten_lieferung_hersteller_lieferung"
      )}</label>
    </div>
    <div style='width: 100%'>
    <input type='radio' id='abholung' name='liefertyp' value='fronten_lieferung_hersteller_abholung'>
    <label for='abholung'>${I18N(
      "fronten_lieferung_hersteller_abholung"
    )}</label>
    </div>
  `;
  const modal = `<oc-modal id="bestellenModal" content="${content}"></oc-modal>`;
  document.documentElement.insertAdjacentHTML("afterbegin", modal);
  const domModal = document.getElementById("bestellenModal");
  domModal.acceptCallback = (modal) => {
    const valueForLieferung = modal.shadowRoot.querySelector('input[name="liefertyp"]:checked').value;
    if(valueForLieferung) {
      if(_.isEmpty(dataObject.Json.stammdaten)) {
        dataObject.Json.stammdaten = {};
      }
      dataObject.Json.stammdaten.hersteller_liefertyp = valueForLieferung;
      if(dataObject.Auftragsstatus == "Bei Händler bestellt") {
        dataObject.Auftragsstatus = "Bei Hersteller bestellt"
      }
      callback(dataObject);
      window.location.reload();
    }

  };
}

function showUserDataModal(dataObject) {
  const content = `
    <h3>Kundendaten zur Bestellung: ${dataObject.Code}</h3>
    <hr></hr>
    <p><b>Vorname:</b> ${dataObject.Json.stammdaten?.vorname || dataObject.Json.kunde?.Vorname}</p>
    <p><b>Nachname:</b> ${dataObject.Json.stammdaten?.nachname || dataObject.Json.kunde?.Nachname}</p>
    <p><b>E-Mail:</b> ${dataObject.Json.stammdaten?.email || dataObject.Json.kunde?.EMailAdresse}</p>
    <p><b>Telefonnummer:</b> ${dataObject.Json.stammdaten?.telefon || dataObject.Json.kunde?.Telefonnummer}</p>
    <p><b>Kundennummer:</b> ${
      dataObject.Json.stammdaten?.kundennummer
        ? dataObject.Json.stammdaten.kundennummer
        : "Keine Angabe"
    }</p>
    <p><b>Liefertyp:</b> ${I18N(dataObject.Json.stammdaten?.liefertyp)}</p>
  `;
  const modal = `<oc-modal content="${content}"></oc-modal>`;
  document.documentElement.insertAdjacentHTML("afterbegin", modal);
}
